const styles = {
  videoContainer: {
    position: "relative",
    width: "100%",
    // 175 because the bottom thumbnail scroll is 137 in height and the close button is 38 in height //
    height: "calc(100% - 175px)",
    overflow: "hidden",
    display: "inline-block",
    background: "#000000",
    "& > iframe": {
      height: "100%",
      width: "calc(100% - 285px)",
    },
  },
  awsVideo: {
    height: "100%",
    width: "calc(100% - 285px)",
    objectFit: "contain",
  },
  text: {
    height: "auto",
    color: "#FFFFFF",
    fontFamily: "CircularStd",
    fontSize: "18px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "23px",
    marginTop: "60px",
    marginLeft: "32px",
  },

  description: {
    padding: "0 20px",
    overflowY: "scroll",
    height: "500px",
    color: "#FFFFFF",
    fontFamily: "CircularStd",
    fontSize: "14px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "22px",
    wordWrap: "break-word",
  },

  title: {
    padding: "0 20px",
    verticalAlign: "top",
    color: "#FFFFFF",
    fontFamily: "CircularStd",
    fontSize: "18px",
    fontWeight: "300",
    letterSpacing: "0",
    lineHeight: "30px",
    textShadow: "0 2px 4px 0 rgba(0,0,0,0.5)",
    overflowWrap: "anywhere",
    right: 2,
    position: "absolute",
    zIndex: 2,
    top: "50px",
    width: "208px",
    marginRight: "35px",
  },
  titleLogo: {
    display: "inline-block",
    height: "36px",
    width: "36px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "contain",
    borderRadius: "50%",
    backgroundImage: (props: any) =>
      `url(https://${props.media[props.selectedIdx].smallurl})`,
  },
  info: {
    background: "transparent",
    border: 0,
    cursor: "pointer",
    position: "absolute",
    right: "3%",
    top: "59px",
    outline: "none",
    zIndex: 1000,
    "@media screen and (max-width : 1200px)": { display: "none" },
  },
  infoPanel: {
    paddingTop: "60px",
    boxSizing: "border-box",
    position: "absolute",
    width: "284px",
    top: 0,
    right: 0,
    height: "100%",
    display: "inline-block",
    backgroundColor: "#000000",
    zIndex: 1,
  },
  shareMenu: {
    cursor: "pointer",
    position: "absolute",
    right: "5px",
    bottom: "5px",
    zIndex: "5000",
  },
};

export default styles;
